import {Image} from "primereact/image";

export default function UserDropdownTemplate(row) {
    if(row) {
        return (
            <div className={'d-flex align-items-center'}>
                <Image src={'http://yii2.easytickets.pro' + row.avatar}
                       imageClassName={'img-40 rounded-circle m-r-15'}/>
                <div>
                    <div>{row.label}</div>
                    <div>{row.position}</div>
                </div>
            </div>
        )
    } else {
        return (<>Выберите сотрудника</>)
    }
}